import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Field } from 'redux-form';
import { propChildren, propShape, } from '../../../../../helpers/custom-prop-types';
import Select2MultipleInputOnlyContainerField from './Select2MultipleInputOnlyContainerField';
const Select2MultipleInputOnlyContainer = (props) => {
    const { children, data, innerProps, selectProps } = props;
    const { fields, inputName, inputValidate, value } = selectProps;
    const fieldIndex = useMemo(() => value.findIndex((v) => v.label === data.label), [data, value]);
    return (_jsx(Field, { component: Select2MultipleInputOnlyContainerField, containerChildren: children, innerProps: innerProps, name: `${fields.name}[${fieldIndex}].${inputName}`, validate: inputValidate }));
};
Select2MultipleInputOnlyContainer.propTypes = {
    children: propChildren().isRequired,
    data: propShape().isRequired,
    innerProps: propShape().isRequired,
    selectProps: propShape().isRequired,
};
export default Select2MultipleInputOnlyContainer;
